/* ============ Shimco · producto.js ============ */
(function () {
  'use strict';

  /* ---------- Acordeones ---------- */
  document.querySelectorAll('.sh-det-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.sh-det-item');
      var abierto = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(abierto));
    });
  });

  /* ---------- Formulario ---------- */
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var nodo = document.getElementById('sh-variantes');
  var datos = nodo ? JSON.parse(nodo.textContent) : [];

  var selectsOpcion = form.querySelectorAll('[data-sh-opcion]');
  var selectLista = form.querySelector('[data-variant-select]');
  var inputId = form.querySelector('[data-sh-variante-id]');
  var precioEl = document.querySelector('[data-sh-precio]');
  var comparaEl = document.querySelector('[data-sh-compara]');
  var msiEl = document.querySelector('[data-sh-msi]');
  var boton = form.querySelector('[data-sh-agregar]');
  var inputCant = form.querySelector('[name="quantity"]');

  function dinero(c) {
    var f = window.shopMoneyFormat || '${{amount}}';
    var v = (c / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return f.replace(/\{\{\s*amount\s*\}\}/, v)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.split('.')[0]);
  }

  var menos = form.querySelector('[data-sh-menos]');
  var mas = form.querySelector('[data-sh-mas]');
  if (menos) menos.addEventListener('click', function () {
    inputCant.value = Math.max(1, Number(inputCant.value) - 1);
  });
  if (mas) mas.addEventListener('click', function () {
    inputCant.value = Number(inputCant.value) + 1;
  });

  function pintar(variante) {
    if (!variante) {
      boton.disabled = true;
      boton.textContent = (window.shTextos || {}).no_disponible || 'No disponible';
      return;
    }

    inputId.value = variante.id;
    if (precioEl) precioEl.textContent = dinero(variante.price);

    if (comparaEl) {
      if (variante.compare_at_price > variante.price) {
        comparaEl.textContent = dinero(variante.compare_at_price);
        comparaEl.hidden = false;
      } else {
        comparaEl.hidden = true;
      }
    }

    if (msiEl) {
      msiEl.textContent = variante.price >= 150000 ? msiEl.dataset.alto : msiEl.dataset.bajo;
    }

    boton.disabled = !variante.available;
    boton.textContent = variante.available
      ? (boton.dataset.txtAgregar || 'Agregar al carrito')
      : (boton.dataset.txtAgotado || 'Agotado');

    if (variante.featured_image && window.shGaleriaPorMedia) {
      window.shGaleriaPorMedia(variante.featured_image.id);
    }

    var url = new URL(window.location);
    url.searchParams.set('variant', variante.id);
    window.history.replaceState({}, '', url);
  }

  function porOpciones() {
    var sel = Array.prototype.map.call(selectsOpcion, function (s) { return s.value; });
    return datos.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }

  selectsOpcion.forEach(function (s) {
    s.addEventListener('change', function () { pintar(porOpciones()); });
  });

  if (selectLista) {
    selectLista.addEventListener('change', function () {
      pintar(datos.find(function (v) { return String(v.id) === selectLista.value; }));
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!window.shAgregarAlCarrito) { form.submit(); return; }

    var original = boton.textContent;
    boton.disabled = true;
    boton.textContent = (window.shTextos || {}).agregando || 'Agregando...';

    window.shAgregarAlCarrito(inputId.value, Number(inputCant.value) || 1)
      .then(function () {
        boton.disabled = false;
        boton.textContent = original;
        if (window.shAbrirCarrito) window.shAbrirCarrito();
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = original;
      });
  });

  if (selectsOpcion.length) pintar(porOpciones());
})();